<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import CountriesApi from "@/services/countries-api";

/**
 * Login component
 */
export default {
  page: {
    title: "Device Validation",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout},

    mounted(){
      this.$cookies.refresh()
      this.testDeviceAndRedirect()
    },

   

  data() {
    return {
      
      

    };
  },

  computed: {
      deviceCode() {
        this.$cookies.refresh()
        return this.$cookies.isKey('cldid') ? this.$cookies.get('cldid') : null;
      },
    },

    

  methods: {

      testDeviceAndRedirect() {
        CountriesApi.getCountries()
          .then((result) => {
            if (result) {
                this.$router.replace({ path: '/' });
            }            
        })
      }

  

  },
 
};
</script>

<style lang="scss">
  



</style>

<template>
  <Layout>
     <div class="row " >

      <div class="col-lg-12 ">
        <div class=" border-warning overflow-hidden" >

          <div class="">
            





















                <div class="unrecognized-device d-flex justify-content-center align-items-center min-vh-90 " style=" border-radius: 5px;opacity:1;">
    <div class="card  border-0 animated fadeInDown" >
      <div class="card-body p-5 text-center">



        <!-- <div class="row pl-4 pr-4">

              <div class="col-12 text-center align-self-end">
                <img src="@/assets/images/logo-dark.png" alt class="img-fluid" />
              </div>
            </div>

            <div class="row pr-4 pt-4 pl-4">
              <div class="col-12 text-right text-center">
                <div class="text-primary pl-4 pr-4 pb-2">
                  <h5 class="text-primary text-center font-weight-bold text-right">Commerce de Pièces Auto en Gros</h5>
                  <span class="text-muted text-center">Tél.: +216 74 204 700,  Email: contact@sopiq.tn</span><br>
                </div>
              </div>
            </div>  -->

        <i class="fas fa-shield-alt fa-4x text-warning mb-4"></i>







        <h3 class="mb-3 mt text-dark font-weight-bold">Validation de votre poste de travail </h3>

        <p class="lead mb-4 text-muted">
          Pour activer votre accès, veuillez nous contacter au numéro suivant :
        </p>

        <h4 class="text-primary mb-3">+216 99 519 269</h4>

        <h5 v-if="deviceCode" class="text-primary mt-5 text-muted mb-3 font-weight-normal">Identifiant du poste <strong class="text-dark ml-1">{{ deviceCode }}</strong></h5>

        <b-button variant="light" @click="$router.replace({ path: '/' })" class="font-weight-bold font-size-16">
            <i class="fa fa-unlock mr-2"/> Réessayer l'accès
        </b-button>


        <p class="mb-4 mt-5 font-size-14">
          Merci de nous communiquer <strong>l'identifiant du poste ci-dessus</strong> lors de l'appel.<br>
          Un membre de notre équipe procédera à la validation de votre poste de travail.
        </p>

        <div class="alert alert-light small d-inline-block text-left">
          <i class="fas fa-info-circle mr-1"></i>
          Cette étape est nécessaire pour garantir la sécurité de votre compte et éviter tout accès non autorisé.
        </div>
      </div>
    </div>
  </div>

























            
          </div>

         
        </div>
        <!-- end card -->


        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style scoped>

.unrecognized-device {
  background: linear-gradient(to right, #f8f9fa, #e9ecef);
  animation: fadeIn 1s ease-in-out;
}

.animated.fadeInDown {
  animation: fadeInDown 1s ease both;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.min-vh-90 {
  min-height: calc(100vh - 100px) !important;
}
</style>
